/**
 * Card Tilt Effect
 * Adds a subtle 3D perspective tilt to product cards based on mouse position.
 * Cards tilt toward the cursor and lift slightly, with a smooth return on leave.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if ('ontouchstart' in window) return; // Skip on touch devices

  var MAX_TILT = 6; // degrees
  var MAX_LIFT = 8; // px
  var PERSPECTIVE = 800; // px
  var LERP = 0.12;

  var cards = [];
  var active = null;
  var raf = null;
  var targetX = 0, targetY = 0;
  var currentX = 0, currentY = 0;

  function init() {
    cards = document.querySelectorAll('.card-wrapper');
    cards.forEach(function (wrapper) {
      var card = wrapper.querySelector('.card--card') || wrapper.querySelector('.card--standard .card__inner');
      if (!card) return;

      wrapper.style.perspective = PERSPECTIVE + 'px';

      wrapper.addEventListener('mouseenter', function () {
        active = card;
        currentX = 0;
        currentY = 0;
        targetX = 0;
        targetY = 0;
        card.style.transition = 'none';
        if (!raf) tick();
      });

      wrapper.addEventListener('mousemove', function (e) {
        var rect = wrapper.getBoundingClientRect();
        // Normalize mouse position to -1...1
        var x = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
        var y = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
        targetX = x * MAX_TILT;
        targetY = -y * MAX_TILT;
      });

      wrapper.addEventListener('mouseleave', function () {
        targetX = 0;
        targetY = 0;
        active = null;
        // Smooth return
        card.style.transition = 'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)';
        card.style.transform = 'rotateX(0deg) rotateY(0deg) translateY(0px)';
      });
    });
  }

  function tick() {
    if (!active && Math.abs(currentX) < 0.01 && Math.abs(currentY) < 0.01) {
      raf = null;
      return;
    }

    currentX += (targetX - currentX) * LERP;
    currentY += (targetY - currentY) * LERP;

    if (active) {
      var lift = Math.sqrt(currentX * currentX + currentY * currentY) / MAX_TILT * MAX_LIFT;
      active.style.transform =
        'rotateY(' + currentX.toFixed(2) + 'deg) rotateX(' + currentY.toFixed(2) + 'deg) translateY(-' + lift.toFixed(1) + 'px)';
    }

    raf = requestAnimationFrame(tick);
  }

  // Init on DOM ready and after section renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify sections load
  document.addEventListener('shopify:section:load', init);
})();
